import * as React from 'react';
import * as classNames from 'classnames';
import {TooltipButton} from '../../tooltip-button/tooltip-button';
import {
  DEFAULT_RUN_CODE_HINT,
  ENTER_KEY,
  CLICK_ME,
  RUN_CODE,
  RUNNING,
  MAC_OS,
} from '../constants';

export interface ISessionEditorRunCodeProps {
  testsRunning: boolean;
  codeRunning: boolean;
  editorValue: string;
  showHint: boolean;
  disabled: boolean;

  onClick: (code: string) => void;
}

export class SessionEditorRunCode extends React.Component<ISessionEditorRunCodeProps, any> {
  public render(): React.ReactElement<{}> {
    const {
      testsRunning,
      codeRunning,
      editorValue,
      disabled,
      showHint,

      onClick,
    } = this.props;

    const buttonClassNames = classNames('btn btn_sm', {
      'btn_violet': !testsRunning,
      'btn_grey': testsRunning,
    });

    return (
      <TooltipButton
        tooltipLabel={showHint ? CLICK_ME : DEFAULT_RUN_CODE_HINT}
        className={buttonClassNames}
        disabled={disabled}
        visible={showHint}
        onClick={() => onClick(editorValue)}
       >
         <span className={classNames({'icon icon--run': !codeRunning, 'spinner': codeRunning})} />
         <span className={'btn__label btn__label_left-blank'}>{codeRunning ? RUNNING : RUN_CODE}</span>
       </TooltipButton>
    );
  }

  public componentDidMount(): void {
    window.addEventListener('keydown', this.runCodeShortCut);
  }

  public componentWillUnmount(): void {
    window.removeEventListener('keydown', this.runCodeShortCut);
  }

  private runCodeShortCut = (event) => {
    const enter: boolean = event.keyCode === ENTER_KEY;
    const meta: boolean = MAC_OS && event.metaKey === true;
    const ctrl: boolean = !MAC_OS && event.ctrlKey === true;
    const {editorValue, onClick} = this.props;

    if (!this.props.codeRunning && enter && (meta || ctrl)) {
      onClick(editorValue);
    }
  };
}
